<!--マップコンポーネント-->
<template>
	<div class='mapPane'>
		<!--マップ表示-->
		<component :is="tagname" :id='mapclass' :ref="mapclass" :class="screenmodeclass" >
			<div v-if="oldPhotoFlag" class="layer_info">
			この空中写真は、国土地理院長の承認を得て、<br>米軍撮影の空中写真を使用したものである。（承認番号 平19総使、第607号）
			</div>
		</component>
		<!--地図にポップアップ表示-->
		<div id='popup' class='ol-popup'>
			<a href='#' id='popup-closer' class='ol-popup-closer'></a>
			<div id='popup-content'></div>
		</div>
	</div>
</template>
<script>
	import 'ol/ol.css';
	import Map from 'ol/Map';
	import View from 'ol/View';
	//import {ZoomSlider} from 'ol/control';
	import {Control,OverviewMap, defaults as defaultControls,ScaleLine} from 'ol/control';
	import {
		DragRotateAndZoom,
		defaults as defaultInteractions,
		MouseWheelZoom
	} from 'ol/interaction';
	import WMSGetFeatureInfo from 'ol/format/WMSGetFeatureInfo';

	import TileLayer from 'ol/layer/Tile';
	import XYZ from 'ol/source/XYZ';
	import { fromLonLat } from 'ol/proj';
	import * as olProj from 'ol/proj';
	import {toLonLat , transform} from 'ol/proj'

	import OSM from 'ol/source/OSM';
	import TileWMS from 'ol/source/TileWMS';
	import LayerGroup from 'ol/layer/Group';

	import VectorTileLayer from 'ol/layer/VectorTile';
	import VectorTileSource from 'ol/source/VectorTile';
	import MVTFormat from 'ol/format/MVT';
	import axios from 'axios';


	import Feature from 'ol/Feature';
	import PointGeon from 'ol/geom/Point';
	import VectorLayer from 'ol/layer/Vector';
	import VectorSource from 'ol/source/Vector';
	import {Icon, Style} from 'ol/style';
	import {add} from 'ol/coordinate';
	import Size from 'ol/size';
	import Pixel from 'ol/Pixel';
	import Util from 'ol/util';
	import Overlay from 'ol/Overlay';
	import GeoJSON from 'ol/format/GeoJSON';
	import LineString from 'ol/geom/LineString';
	import {register} from 'ol/proj/proj4';
	import proj4 from 'proj4';
	//各種地図用のレイヤ
	//js/BaseLayer.jsから読み込むと画面分割すると必ず片側画面が地図表示されなくなるので、分離記述を中止
	// import BaseLayer from '../js/BaseLayer.js'
	
	//GoogleMaps読込み
	import 'olgm/olgm.css';
	import GoogleLayer from 'olgm/layer/Google';
	import {defaults as olgmDefaultInteractions} from 'olgm/interaction';
	import OLGoogleMaps from 'olgm/OLGoogleMaps';

	//proj4.defs("EPSG:2449","+proj=tmerc +lat_0=36 +lon_0=137.1666666666667 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs");
	//register(proj4);
	const epsg_2449_def = '+proj=tmerc +lat_0=36 +lon_0=137.1666666666667 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs';
	var control;

	export default {
		name: 'mapPane',
		created: function() {
			//URLクエリーから自由選択画面か否かを取得
			if ((this.$route.query.mode==='1')||(this.$route.query.mode==='2')||(this.$route.query.mode==='3')||(this.$route.query.mode==='4')||(this.$route.query.mode==='5')){
				this.mode=this.$route.query.mode;
			}else{
				this.mode='1';
			}
			console.log('MapPane this.$route.query.mode:' + this.mode);

		},
		mounted: function () {
			console.log('MapPane isMobileAny:' + this.$isMobileAny);

			// this.emitToApp();
			//親コンポーネントから渡された値でデータを初期化
			this.lon = this.value.lon;
			this.lat = this.value.lat;
			this.lonValue = this.value.lonValue;
			this.latValue = this.value.latValue;
			this.scaleValue = this.value.scaleValue;
			this.zoomValue = this.value.zoomValue;
			this.cityName = this.value.cityName;
			this.comment_q = this.value.comment_q;
			this.time = this.value.time;
			this.timeDist = this.value.timeDist;
			this.time30 = this.value.time30;
			this.depth = this.value.depth;
			this.si = this.value.si;
			this.pl = this.value.pl;
			this.mcode = this.value.mcode;
			this.height = this.value.height;
			this.heightDist = this.value.heightDist;
			this.layerMenuPos = this.value.layerMenuPos;
			// this.dicBaseLayers = this.value.dicBaseLayers;
			// this.dicLayers = this.value.dicLayers;

			//右側地図のチェック済みレイヤーをセーブ
			if ( this.screenmode === 'rightscreen'){
				this.checkedRightBackgroundLayer = this.value.checkedRightBackgroundLayer;
				this.checkedRightLayers = JSON.parse(this.value.checkedRightLayers);
				this.checkedRightAllLayers = JSON.parse(this.value.checkedRightAllLayers);
				console.log('MapPane mounted checkedRightLayers:' + this.checkedRightLayers);
				console.log('MapPane mounted checkedRightAllLayers:' + this.checkedRightAllLayers);
				console.log('MapPane mounted lat:' + this.lon);
				console.log('MapPane mounted lat:' + this.lat);
				console.log('MapPane mounted lonValue:' + this.lonValue);
				console.log('MapPane mounted latValue:' + this.latValue);
				//-------------------------------------------
				//右側地図の時は、チェック済みレイヤを戻す
				//-------------------------------------------
				this.checkedLayers = this.checkedRightLayers
				this.checkedAllLayers = this.checkedRightAllLayers
			}

			// マップオブジェクト生成
			this.mapCreate();
		},

		data () {
			return {
				map: null,
				olGM:null,
				gmap:null,
	
				lon: "",
				lat: "",
				lonValue: "",
				latValue: "",
				scaleValue: "",
				zoomValue:11,
				cityName:"",
				comment_q:"",
				time:"",
				timeDist:"",
				time30:"",
				depth:"",
				si:"",
				pl:"",
				mcode:"",
				height:"",
				heightDist:"",
				layerMenuPos:"",
				dicBaseLayers:"",
				dicLayers:"",
				kenFlg : true,
				checkedLayers : [],     //チェックされているレイヤーチェックボックス
				checkedAllLayers : [],  //チェックされている震度、液状化のレイヤーラジオボタン
				mode:"",
				checkedRightBackgroundLayer:"",
				checkedRightLayers:[],
				checkedRightAllLayers:[],
				checkedRightDispLayers:[],
	
				mapData: {
					lon:0.0,
					lat:0.0,
					lonValue: "緯度 =            ",
					latValue: "経度 =            ",
					scaleValue: "",
					zoomValue: 11,
					cityName: "",
					comment_q: "",
					time: "",
					timeDist: "",
					time30: "",
					depth: "",
					si: "",
					pl: "",
					mcode:"",
					height: "",
					heightDist: "",
					layerMenuPos: "single",
					dicBaseLayers:"",
					dicLayers:"",
					checkedRightBackgroundLayer:"",
					checkedRightLayers:"",
					checkedRightAllLayers:"",
				},
				shindoLayer: "L102",
				ekijyoukaLayer: "L112",
	
				//currZoom:11,
				isDoubleScreen: false,
				mapclassname: "map1",
	
				traceflag : false,//地図ドラッグ時の自動処理の有効フラグ
				centerMemL:0,//ループ防止：前回メソッド呼び出し時の中心座標を保持する
				searchingflag : false,//検索リクエスト重複を防ぐフラグ：検索中はtrue
	
				features: {
					tsunami_time: [],
					tsunami_height: [],
					si:[]
				},
				oldPhotoFlag: false,
			}
		},
		props: {
			//value属性で親コンポーネントからデータを受け取る
			screenmode: {
				type: String
			},
			tagname: {
				type: String
			},
			value: {
				type: Object,
				required: true,
			},
		},
		computed: {
			screenmodeclass() {
				switch(this.screenmode) {
					case 'rightscreen':
						this.mapclassname='map2';
						return `rightscreen`
					case 'singlescreen':
						this.mapclassname='map1';
						return `singlescreen`
					case 'doublescreen':
						this.mapclassname='map1';
						return `doublescreen`
				}
			},
			mapclass() {
				switch(this.screenmode) {
					case 'rightscreen':
					return `map2`
					case 'singlescreen':
					return `map1`
					case 'doublescreen':
					return `map1`
				}
			}
		},
		methods: {
			setMode:function(mode) {
				this.mode=mode;
				console.log('setMode'+this.mode);
			},
			// マップオブジェクト生成
			mapCreate: function() {
				//=================================================
				//メイン地図のレイヤー定義 ここから開始
				//=================================================
				//js/BaseLayer.jsから読み込むと画面分割すると必ず片側画面が地図表示されなくなるので、分離記述を中止
				console.log(this.geoserverWmsUrl);
				const geoserver_url =this.geoserverWmsUrl;
				const chiiki_url = this.chiikiMapUrl;

				//GoogleMapsのレイヤはLayerGroup内に記述すると表示されないので、個別に定義
				var googleLayer = new GoogleLayer({
					visible:true,
					dispName:'地図',
					groupName:'背景',
					title:'L001',
				});
				var googleLayerPhoto = new GoogleLayer({
					mapTypeId: google.maps.MapTypeId.SATELLITE,
					visible:false,
					dispName:'空中写真（現在）',
					groupName:'背景',
					title:'L002',
				});
				//各種レイヤ定義
				var baseLayerGroup = new LayerGroup({
					layers: [
						//L999 市町村ポリゴン	市町村名表示に利用	/geoserver/wms/	bousai_aichi:city	no_draw	-	4326
						new TileLayer({
							source: new TileWMS({
								url: geoserver_url,
								params: {
									'LAYERS': 'bousai_aichi:city',
									'TILED': true,
								},
								projection: 'EPSG:4326',
								styles: 'no_draw',
							}),
							visible:true,
							dispName:'市町村ポリゴン',
							groupName:'市町村',
							title:'L999'
						}),
						// 地図　地理院タイル
						/*
						new TileLayer({
							source: new XYZ({
								url: 'https://cyberjapandata.gsi.go.jp/xyz/pale/{z}/{x}/{y}.png',
								// attributions: '<a href="http://www.gsi.go.jp/kikakuchousei/kikakuchousei40182.html" target="_blank">地理院タイル</a>',
								attributionsCollapsible: false,
								tileSize: [256, 256],
								projection: 'EPSG:3857',
								minZoom: 0,
								maxZoom: 18
							}),
							visible:true,
							dispName:'地図',
							groupName:'背景',
							title:'L001'
						}),
						// 空中写真（現在）地理院タイル
						new TileLayer({
							source: new XYZ({
								url: 'https://cyberjapandata.gsi.go.jp/xyz/seamlessphoto/{z}/{x}/{y}.jpg',
								// attributions: '<a href="http://www.gsi.go.jp/kikakuchousei/kikakuchousei40182.html" target="_blank">地理院タイル</a>',
								attributionsCollapsible: false,
								tileSize: [256, 256],
								projection: 'EPSG:3857',
								minZoom: 0,
								maxZoom: 18
							}),
							visible:false,
							dispName:'空中写真（現在）',
							groupName:'背景',
							title:'L002'
						}),
						*/
						//空中写真（過去）
						new TileLayer({
							source: new TileWMS({
								url: geoserver_url,
								params: {
									'LAYERS': 'bousai_aichi:old_photo',
									'TILED': true
								},
								projection: 'EPSG:2449',
								styles: 'old_photo',
							}),
							visible:false,
							dispName:'空中写真（過去）',
							groupName:'背景',
							title:'L003'
						}),
						//L101 震度	愛知県データ
						new TileLayer({
							source: new TileWMS({
								url: geoserver_url,
								params: {
									'LAYERS': 'bousai_aichi:si',
									'TILED': true,
								},
								projection: 'EPSG:4326',
								styles: 'si',
							}),
							visible:false,
							dispName:'震度愛知県',
							groupName:'',
							title:'L101'
						}),
						//L102 震度 名古屋市データ	/geoserver/wms/	bousai_aichi:si_23100	si	si	4326
						new TileLayer({
							source: new TileWMS({
								url: geoserver_url,
								params: {
									'LAYERS': 'bousai_aichi:si_23100',
									'TILED': true,
								},
								projection: 'EPSG:4326',
								styles: 'si',
							}),
							visible:false,
							dispName:'震度名古屋市',
							groupName:'',
							title:'L102'
						}),
						//L111 液状化 愛知県データ	/geoserver/wms/	bousai_aichi:pl	pl	pl	4326
						new TileLayer({
							source: new TileWMS({
								url: geoserver_url,
								params: {
									'LAYERS': 'bousai_aichi:pl',
									'TILED': true,
								},
								projection: 'EPSG:4326',
								styles: 'pl',
							}),
							visible:false,
							dispName:'液状化愛知県',
							groupName:'',
							title:'L111'
						}),
						//L112 液状化 名古屋市データ	/geoserver/wms/	bousai_aichi:pl_23100	pl	pl	4326
						new TileLayer({
							source: new TileWMS({
								url: geoserver_url,
								params: {
									'LAYERS': 'bousai_aichi:pl_23100',
									'TILED': true,
								},
								projection: 'EPSG:4326',
								styles: 'pl',
							}),
							visible:false,
							dispName:'液状化名古屋市',
							groupName:'',
							title:'L112'
						}),
						//L121 土地条件図 シナリオのコメント：「COMMENT_Q」カラム	/geoserver/wms/	bousai_aichi:landform	landform	syochikei	30167
						new TileLayer({
							source: new TileWMS({
								url: geoserver_url,
								params: {
									'LAYERS': 'bousai_aichi:landform',
									'TILED': true,
								},
								projection: 'EPSG:30167',
								styles: 'landform',
							}),
							visible:false,
							dispName:'土地条件図',
							groupName:'',
							title:'L121'
						}),
						//L201 津波波高     /geoserver/wms/	bousai_aichi:tsunami_height	tsunami_height	height	2449
						new TileLayer({
							source: new TileWMS({
								url: geoserver_url,
								params: {
									'LAYERS': 'bousai_aichi:tsunami_height',
									'TILED': true,
								},
								projection: 'EPSG:2449',
								styles: 'tsunami_height',
							}),
							visible:false,
							dispName:'津波波高',
							groupName:'',
							title:'L201'
						}),
						//L211 浸水深 "値取得用：「depth」カラム/ 描画しない"	/geoserver/wms/	bousai_aichi:tsunami_depth	no_draw	-	2449
						new TileLayer({
							source: new TileWMS({
								url: geoserver_url,
								params: {
									'LAYERS': 'bousai_aichi:tsunami_depth',
									'TILED': true,
								},
								projection: 'EPSG:2449',
								styles: 'no_draw',
							}),
							visible:false,
							// visible:true,
							dispName:'',
							groupName:'',
							title:'L211N'
						}),
						//L212 浸水深 描画用	/geoserver/wms/	bousai_aichi:tsunami_depth_class	tsunami_depth	class	2449
						new TileLayer({
							source: new TileWMS({
								url: geoserver_url,
								params: {
									'LAYERS': 'bousai_aichi:tsunami_depth_class',
									'TILED': true,
								},
								projection: 'EPSG:2449',
								styles: 'tsunami_depth',
							}),
							visible:false,
							dispName:'浸水深',
							groupName:'',
							title:'L211'
						}),
						//L221 津波到達時間     /geoserver/wms/	bousai_aichi:tsunami_time	tsunami_time	time	2449
						new TileLayer({
							source: new TileWMS({
								url: geoserver_url,
								params: {
									'LAYERS': 'bousai_aichi:tsunami_time',
									'TILED': true,
								},
								projection: 'EPSG:2449',
								styles: 'tsunami_time',
							}),
							visible:false,
							dispName:'津波到達時間',
							groupName:'',
							title:'L221'
						}),
						//L231 浸水深が30cmに到達する時間 "値取得用：「time」カラム 描画しない"	/geoserver/wms/	bousai_aichi:tsunami_30cm_time	no_draw	-	2449
						new TileLayer({
							source: new TileWMS({
								url: geoserver_url,
								params: {
									'LAYERS': 'bousai_aichi:tsunami_30cm_time',
									'TILED': true,
								},
								projection: 'EPSG:2449',
								styles: 'no_draw',
							}),
							visible:false,
							// visible:true,
							dispName:'',
							groupName:'',
							title:'L231N'
						}),
						//L232 浸水深が30cmに到達する時間 描画用	/geoserver/wms/	bousai_aichi:tsunami_30cm_time_class	tsunami_30cm_time	class	2449
						new TileLayer({
							source: new TileWMS({
								url: geoserver_url,
								params: {
									'LAYERS': 'bousai_aichi:tsunami_30cm_time_class',
									'TILED': true,
								},
								projection: 'EPSG:2449',
								styles: 'tsunami_30cm_time',
							}),
							visible:false,
							dispName:'浸水深が30cmに到達する時間',
							groupName:'',
							title:'L231'
						}),
						//L241 標高（5mメッシュ） バイナリ画像	/geoserver/wms/	bousai_aichi:dem5m	dem	-	4612
						new TileLayer({
							source: new TileWMS({
								url: geoserver_url,
								params: {
									'LAYERS': 'bousai_aichi:dem5m',
									'TILED': true,
								},
								projection: 'EPSG:4612',
								styles: 'dem',
							}),
							visible:false,
							dispName:'標高（5mメッシュ）',
							groupName:'',
							title:'L241'
						}),
						//L242 標高（10mメッシュ） バイナリ画像	/geoserver/wms/	bousai_aichi:dem10m	dem	-	4612
						new TileLayer({
							source: new TileWMS({
								url: geoserver_url,
								params: {
									'LAYERS': 'bousai_aichi:dem10m',
									'TILED': true,
								},
								projection: 'EPSG:4612',
								styles: 'dem',
							}),
							visible:false,
							dispName:'標高（10mメッシュ）',
							groupName:'',
							title:'L251'
						}),
						//L301 指定緊急避難場所（地域防災の広場の公開レイヤ）
						new TileLayer({
							source: new TileWMS({
								url: chiiki_url,
								params: {
									'LAYERS': 'c7',
									'TILED': true,
									'VERSION': '1.1.1',
								},
								projection: 'EPSG:900913',
							}),
							visible:false,
							dispName:'指定緊急避難場所(国土地理院)',
							groupName:'',
							title:'L301'
						}),
						//L302 緊急輸送道路（地域防災の広場の公開レイヤ）
						new TileLayer({
							source: new TileWMS({
								url: chiiki_url,
								params: {
									'LAYERS': 'c8',
									'TILED': true,
									'VERSION': '1.1.1',
								},
								projection: 'EPSG:900913',
							}),
							visible:false,
							dispName:'緊急輸送道路(国土数値情報)',
							groupName:'',
							title:'L302'
						}),
					]
				});
				//俯瞰地図用のレイヤ
				var baseLayerSubGroup = new LayerGroup({
					layers: [
						new TileLayer({
							// 地理院タイルを指定
							source: new XYZ({
								url: 'https://cyberjapandata.gsi.go.jp/xyz/pale/{z}/{x}/{y}.png',
								attributions: '<a href="http://www.gsi.go.jp/kikakuchousei/kikakuchousei40182.html" target="_blank">地理院タイル</a>',
								attributionsCollapsible: false,
								tileSize: [256, 256],
								minZoom: 0,
								maxZoom: 18
							}),
							visible:true,
							title:'AAA'
						})
					]
				});
				//var overViewLayer = new GoogleLayer();
				//=================================================
				//メイン地図のレイヤー定義 ここまで
				//=================================================

				//俯瞰地図コントロール
				var overviewMapControl = new OverviewMap({
					className: 'ol-overviewmap ol-custom-overviewmap',
					layers: [
						baseLayerSubGroup ],
						//overViewLayer ],
					collapseLabel: '\u00AB',
					label: '\u00BB',
					collapsed: true,
					// autoPan: true,
					// maximized: false,
					minRatio:10,
					maxRatio:10,
					minRectSize:150,
					// view: new View ({
					//     zoom: 7,
					// }),
					mapOptions: {
							numZoomLevels: 1
						}
				});


				// 初期位置設定（中心位置指定）
				var view = new View({
					center: fromLonLat(this.centerLonLat),
					zoom: 11,
					minZoom: 10,
					maxZoom: 18,
				});

				// 中心マーカー
				var CenterMarkControl = /*@__PURE__*/(function (Control,centerMarkImage) {
				function CenterMarkControl(opt_options) {
					var options = opt_options || {};

					var cmark = document.createElement('cmark');
					cmark.innerHTML = `<img src="${centerMarkImage}">`;
					var element = document.createElement('div');
					element.className = 'absolute_transform';
					element.appendChild(cmark);

					Control.call(this, {
						element: element,
						target: options.target,
					});
					// cmark.addEventListener('click', this.handleRotateNorth.bind(this), false);
				}
				if ( Control ) CenterMarkControl.__proto__ = Control;
				CenterMarkControl.prototype = Object.create( Control && Control.prototype );
				CenterMarkControl.prototype.constructor = CenterMarkControl;
				// CenterMarkControl.prototype.handleRotateNorth = function handleRotateNorth () {
				//     this.getMap().getView().setRotation(0);
				// };
				return CenterMarkControl;
				}(Control,this.centerMark));

				//マップあいちのレイヤ読込
				//土砂災害情報マップ
				var saboLayers = [['c200367','土砂災害警戒区域（土石流）'],['c200368','土砂災害特別警戒区域（土石流）'],['c200369','土砂災害警戒区域（急傾斜地の崩壊）'],['c200370','土砂災害特別警戒区域（急傾斜地の崩壊）'],['c200371','土砂災害警戒区域（地すべり）'],['c200372','土石流危険渓流による危険区域（基礎調査完了済）'],['c200374','急傾斜地崩壊危険箇所（基礎調査完了済）'],['c200375','地すべり危険箇所（基礎調査完了済）'],['c200373','土石流危険流域']];
				var saboLayerGroup = createLayerGroup(saboLayers,false);
				//水害情報マップ
				//国管理河川
				var riverNat = [['c204269','木曽川L2'],['c204271','長良川L2'],['c204285','庄内川L2'],['c204287','矢田川L2'],['c204277','矢作川L2'],['c204279','豊川L2'],['c204281','豊川放水路L2'],['c204270','木曽川L1'],['c204272','長良川L1'],['c204286','庄内川L1'],['c204288','矢田川L1'],['c204278','矢作川L1'],['c204280','豊川L1'],['c204282','豊川放水路L1']];
				var riverNatGroup = createLayerGroup(riverNat,true);
				//県管理河川, 県管理河川+浸水想定区域図, L2
				var riverPrefAreaL2 = [['c204541','県管理河川'],['c206118','新川L2'],['c205637','日光川L2'],['c205636','天白川L2'],['c206237','境川・逢妻川L2'],['c206119','五条川（上流）L2'],['c206120','五条川（下流）L2'],['c206121','青木川L2'],['c206122','大山川L2'],['c205643','蟹江川L2'],['c205644','福田川L2'],['c205642','領内川L2'],['c205641','扇川L2'],['c205638','矢田川L2'],['c205639','香流川L2'],['c205640','内津川L2'],['c205645','矢作古川L2'],['c205647','広田川L2（※修正中）'],['c205646','乙川L2'],['c205648','籠川L2'],['c205649','柳生川L2'],['c206303','逢妻女川L2'],['c206293','八田川L2'],['c206221','阿久比川L2'],['c206241','猿渡川L2'],['c206229','梅田川L2'],['c206233','音羽川L2'],['','山崎川L2'],['','佐奈川L2']];
				var riverPrefAreaL2Group = createLayerGroup(riverPrefAreaL2,true);
				//県管理河川, 浸水想定区域図, L1
				var riverPrefAreaL1 = [['c206142','新川L1'],['c205620','日光川L1'],['c205619','天白川L1'],['c206238','境川・逢妻川L1'],['c206143','五条川（上流）L1'],['c206144','五条川（下流）L1'],['c206145','青木川L1'],['c206146','大山川L1'],['c205628','蟹江川L1'],['c205629','福田川L1'],['c205627','領内川L1'],['c205626','扇川L1'],['c205623','矢田川L1'],['c205624','香流川L1'],['c205625','内津川L1'],['c205630','矢作古川L1（※該当の区域はない）'],['c205632','広田川L1'],['c205631','乙川L1'],['c205633','籠川L1'],['c205634','柳生川L1'],['c206305','逢妻女川L1'],['c206294','八田川L1'],['c206222','阿久比川L1'],['c206242','猿渡川L1'],['c206230','梅田川L1'],['c206234','音羽川L1'],['','山崎川L1'],['','佐奈川L1']];
				var riverPrefAreaL1Group = createLayerGroup(riverPrefAreaL1,true);
				//県管理河川, 浸水予想図, L2
				var riverPrefEstL2 = [['c205661','日光川流域L2'],['c205660','天白川流域L2'],['c205662','矢田川・香流川流域L2'],['c205663','内津川流域L2'],['c205656','矢作古川・広田川流域L2'],['c205665','乙川流域L2'],['c205666','籠川流域L2'],['c205667','柳生川流域L2'],['c206239','境川・逢妻川流域L2'],['c206044','八田川流域L2'],['c206035','繁田川・新繁田川流域L2'],['c206041','水野川流域L2'],['c206038','うぐい川流域L2'],['c206029','新川流域L2'],['c206223','阿久比川・十ヶ川流域L2'],['c206243','猿渡川流域L2'],['c206231','梅田川流域L2'],['c206235','音羽川流域L2'],['c206219','郷瀬川流域L2'],['c206245','前川流域L2'],['c206247','鹿乗川流域L2'],['c206249','高浜川流域L2'],['c206251','蜆川流域L2'],['c206225','北浜川流域L2'],['c206227','矢崎川流域L2'],['c206352','豊川上流支川(1)L2'],['c206356','石川流域L2'],['c206360','堀川流域L2'],['c206364','新川流域（知多）L2'],['c206459','矢作川中流支川L2'],['c206463','矢作川上流支川L2']];
				var riverPrefEstL2Group = createLayerGroup(riverPrefEstL2,true);
				//県管理河川, 浸水予想図, L1
				var riverPrefEstL1 = [['c205651','日光川流域L1'],['c205650','天白川流域L1'],['c205652','矢田川・香流川流域L1'],['c205653','内津川流域L1'],['c205657','矢作古川・広田川流域L1'],['c205655','乙川流域L1'],['c205658','籠川流域L1'],['c205659','柳生川流域L1'],['c206240','境川・逢妻川流域L1'],['c206097','八田川流域L1'],['c206090','繁田川流域L1（※該当の区域はない）'],['c206092','新繁田川流域L1'],['c206095','水野川流域L1'],['c206093','うぐい川流域L1'],['c206064','新川流域L1'],['c206224','阿久比川・十ヶ川流域L1'],['c206244','猿渡川流域L1'],['c206232','梅田川流域L1'],['c206236','音羽川流域L1'],['c206220','郷瀬川流域L1'],['c206246','前川流域L1'],['c206248','鹿乗川流域L1'],['c206250','高浜川流域L1'],['c206252','蜆川流域L1'],['c206226','北浜川流域L1'],['c206228','矢崎川流域L1'],['c206354','豊川上流支川(1)L1'],['c206358','石川流域L1'],['c206362','堀川流域L1'],['c206366','新川流域（知多）L1'],['c206461','矢作川中流支川L1'],['c206465','矢作川上流支川L1']];
				var riverPrefEstL1Group = createLayerGroup(riverPrefEstL1,true);
				//AED、特定河川、高潮、津波、水位計、雨量計、監視カメラ、浸水実績、道路冠水想定箇所
				var otherLayers = [['c214671','AED設置箇所'],['c200598','新川流域'],['c200599','境川(逢妻川)・猿渡川流域'],['c204283','高潮'],['c204284','津波(見直し前)'],['c205031','津波最大浸水深'],['c204138','水位計-国管理'],['c204139','水位計-県管理'],['c204142','雨量計'],['c204144','監視カメラ-国管理'],['c204145','監視カメラ(CCTV)-県管理'],['c204146','監視カメラ(簡易)-県管理'],['c205389','S46.8洪水'],['c205390','S34伊勢湾台風'],['c205391','S47.7洪水'],['c205392','S49.6洪水'],['c205393','S49.7洪水'],['c205394','S50.7洪水'],['c205395','S51.5洪水'],['c205396','S51.9洪水'],['c205408','H3.9 台風18号'],['c205401','H20.8洪水'],['c205409','H12.9洪水'],['c203657','アンダーパス（国管理）'],['c203658','アンダーパス以外（国管理）'],['c203659','アンダーパス（県管理）'],['c203660','アンダーパス以外（県管理）'],['c203661','アンダーパス（市町村管理）'],['c203662','アンダーパス以外（市町村管理）']];
				var otherLayersGroup = createLayerGroup(otherLayers,false);
				
				//メイン地図コントロール
				//PC
				if (!this.$isMobileAny){
					this.map = new Map ({
						target: this.mapclassname,
						layers: [
							googleLayer,
							googleLayerPhoto,
							baseLayerGroup,
							saboLayerGroup,
							riverNatGroup,
							riverPrefAreaL2Group,
							riverPrefAreaL1Group,
							riverPrefEstL2Group,
							riverPrefEstL1Group,
							otherLayersGroup,
							//vectorLayer
						],
						updateSize: this.fullScreen,
						controls: defaultControls().extend([
							new ScaleLine(),
							new DragRotateAndZoom(),
							overviewMapControl,
							new CenterMarkControl()
						]),
						//マウスホイールによる縮尺調整をZoomLevelに合わせる
						//interactions: defaultInteractions({mouseWheelZoom: false}).extend([
						interactions: olgmDefaultInteractions({mouseWheelZoom: false}).extend([
							new MouseWheelZoom({
								constrainResolution: true
							})
						]),
						view: view
					});
				//スマホ
				}else{
					this.map = new Map ({
						target: this.mapclassname,
						layers: [
							googleLayer,
							googleLayerPhoto,
							baseLayerGroup,
							saboLayerGroup,
							riverNatGroup,
							riverPrefAreaL2Group,
							riverPrefAreaL1Group,
							riverPrefEstL2Group,
							riverPrefEstL1Group,
							otherLayersGroup,
							//vectorLayer
						],
						updateSize: this.fullScreen,
						interactions:olgmDefaultInteractions({
							dragPan:true,
							pinchZoom:true,
							pinchRotate: false,
							doubleClickZoom: true,
							altShiftDragRotate: false,
						}),
						controls: defaultControls({zoom: false, rotate: false}).extend([
							new ScaleLine(),
							//new DragRotateAndZoom(),
							new CenterMarkControl(),
						]),
						view: view
					});
				}
				var olGM = new OLGoogleMaps({map: this.map});
				olGM.activate();
				this.gmap = olGM.getGoogleMapsMap();
				//Satelliteのイメージが拡大時に自動的に斜め写真になるので無効化
				this.gmap.setTilt(0);
				
				var wkdicBaseLayers ={}
				var wkdicLayers ={}
				this.map.getLayers().forEach(function(layer, i) {
					if (layer instanceof LayerGroup) {
						layer.getLayers().forEach(function(sublayer, j) {
							if (sublayer.get('groupName')==='背景'){
								// this.dicBaseLayers[sublayer.get('title')] = sublayer.get('dispName');
								wkdicBaseLayers[sublayer.get('title')] = sublayer.get('dispName');
							}
							if (sublayer.get('groupName')===''){
								// this.dicLayers[sublayer.get('title')] = sublayer.get('dispName');
								wkdicLayers[sublayer.get('title')] = sublayer.get('dispName');
							}
							//console.log("layer title:"+sublayer.get('dispName'));
						});
					}else{//GoogleMaps
						if (layer.get('groupName')==='背景'){
							// this.dicBaseLayers[sublayer.get('title')] = sublayer.get('dispName');
							wkdicBaseLayers[layer.get('title')] = layer.get('dispName');
						}
					}
				});
				this.dicBaseLayers = wkdicBaseLayers;
				this.dicLayers = wkdicLayers;

				//map.addlayer(baseLayerGroup);
				//PC
				if (!this.$isMobileAny){
					//var zoomslider = new ZoomSlider();
					//this.map.addControl(zoomslider);
					var scaleLineControl = new ScaleLine();
					this.map.addControl(scaleLineControl);
				}
				//this.currZoom = this.map.getView().getZoom();
				var setZoom = Math.round(this.zoomValue);
				this.map.getView().setZoom(setZoom);
				//-------------------------------------------
				//右側地図の時は、レイヤーメニューのチェック状態に地図表示を再現する
				//-------------------------------------------
				if ( this.screenmode === 'rightscreen'){
					var wkLayers = [];
					if (this.checkedRightBackgroundLayer != undefined){
						wkLayers.push(this.checkedRightBackgroundLayer);
					}else{
						wkLayers.push("L001");//初回表示は「地図」
					}
					this.checkedRightLayers.forEach(function( value ) {
						if ((value ==='L100')||(value ==='L110')){
						}else{
							wkLayers.push(value) ;
						}
					});
					this.checkedRightAllLayers.forEach(function( value ) {
						wkLayers.push(value) ;
					});
					console.log('MapPane mounted wkLayers:' + wkLayers);
					console.debug(' this.screenmode:'+this.screenmode);
					this.map.getLayers().forEach(function(layer, i) {
						if (layer instanceof LayerGroup) {
							layer.getLayers().forEach(function(sublayer, j) {
								// if ((sublayer.get('title')==='L999')||(sublayer.get('title')==='L211N')||(sublayer.get('title')==='L231N')){
								if (sublayer.get('title')==='L999'){
								}else{
									if (wkLayers.indexOf(sublayer.get('title'))!=-1){
										console.debug('title:'+sublayer.get('title'));
										sublayer.setVisible(true);
									}
								}
							});
						//}else{//for GoogleMaps
						//	//地図初期化時の表示情報が残っているので、一旦非表示
						//	layer.setVisible(false);
						//	//表示対象になっていれば、表示
						//	if (wkLayers.indexOf(layer.get('title'))!=-1){
						//		layer.setVisible(true);
						//	}
						}
					});
				}

				this.map.on('moveend', this.onMoveEnd);

				//-------------------------------------------
				//右側地図の時は、初期中心位置を左地図に合わせる
				//-------------------------------------------
				if ( this.screenmode === 'rightscreen'){
					console.debug('checkedLayers:'+this.checkedLayers);
					console.debug('checkedAllLayers:'+this.checkedAllLayers);
					this.centerMove(this.lon,this.lat);
					this.onMoveEnd(NaN);
				}

				//GoogleMaps対応
				//すぐに実行しても反映されない時があるので、少し待ってから実行
				/*
				var newZoom = this.map.getView().getZoom();
				newZoom = Math.round(newZoom);
				this.map.getView().setZoom(newZoom);
				var gmapThis = this.gmap;
				setTimeout(function() {
					gmapThis.setZoom(newZoom);
				}, 1000);
				*/

				this.emitToApp();
				return this.map;
			},
			update() {
				if (this.isDoubleScreen){
					var center = toLonLat( this.map.getView().getCenter() );
					this.centerMove(center[1],center[0])
					this.$forceUpdate();
					this.$nextTick(() => {
							console.log(this.isDoubleScreen);
						})
				}else{
					this.$forceUpdate();
					this.$nextTick(() => {
							console.log(this.isDoubleScreen);
						})
				}
			},
			// 地図中央の経緯度を取得
			onMoveEnd: function(evt) {
				console.log('this.mode: ' + this.mode);
				var newZoom = this.map.getView().getZoom();
				newZoom = Math.round(newZoom);//整数化
				console.log('zoom end, new zoom: ' + newZoom);
				this.zoomValue = newZoom;
				//console.log('zoom end, this.currZoom: ' + this.currZoom);
				//if (this.currZoom != newZoom) {
				//	console.log('zoom end, new zoom: ' + newZoom);
				//	//todo ここで右画面のzoomを通知
				//	this.zoomValue = newZoom;
				//}
				//GoogleMapsのZoomレベルが、何故か10大きくリクエストされているので補正
				//https://github.com/mapgears/ol3-google-maps/issues/216
				//console.log("olmap  zoom : "+ this.zoomValue);
				//console.log("google zoom : "+ this.gmap.getZoom());
				this.map.getView().setZoom(newZoom);
				//this.gmap.setZoom(newZoom);
				
				var center = toLonLat( this.map.getView().getCenter());

				this.lon = center[1];
				this.lat = center[0];
				this.lonValue = getDMS(center[1]);
				this.latValue = getDMS(center[0]);

				//縮尺表示
				var unit = this.map.getView().getProjection().getUnits();
				var resolution = this.map.getView().getResolution();
				var inchesPerMetre = 39.37;
				//var dpi = 100;
				var dpi = 96;
				//100の位を四捨五入してカンマ区切りに
				this.scaleValue = (Math.round(resolution * olProj.METERS_PER_UNIT[unit] * inchesPerMetre * dpi / 1000) * 1000).toLocaleString();

				// var map = evt.map;
				//var map = this.map;
				//var extent = map.getView().calculateExtent(map.getSize());
				//var center2 = this.map.getView().getCenter();

				//--------------------------------------
				//市区町村レイヤー取得
				//--------------------------------------
				var wkcheckedLayers = this.checkedLayers;
				var wkcheckedAllLayers = this.checkedAllLayers;
				var wkShindoLayer= this.shindoLayer;
				var wkEkijyoukaLayer= this.ekijyoukaLayer;
				console.debug('wkcheckedAllLayers'+ wkcheckedAllLayers);
				console.debug('wkShindoLayer'+ wkShindoLayer);
				var old_kenFlg = this.kenFlg

				var ekijyoukaL = '';
				var shindoL = '';
				var wmsSource = '';
				// var center_coordinate = this.map.getView().getCenter();
				var center_coordinate = transform(this.map.getView().getCenter(), 'EPSG:3857', 'EPSG:4326');
				var viewResolution = /** @type {number} */ (this.map.getView().getResolution());
				var url = this.getUrl('L999',center_coordinate,viewResolution,'EPSG:4326');
				//中心座標の市区町村レイヤー属性取得
				//moveendイベントでは中心座標範囲を調整しないとエラーとなる、singleクリックイベントは正常終了
				if (url) {
					//BBOX変換
					url = this.bboxConvert2(url,0.0001);
					axios.get(url)
					.then(response => {
						var data = response.data;
						if (data['features'].length != 0){
							this.cityName = data['features'][0]['properties']['市区町'];
							// 震度、又は液状化が選択されていてかつ中心座標の市町村ポリゴンのcodeが以下の場合
							// 名古屋市の区（23101-23116、23100番台）：
							// 　　　市町村が選択された場合：震度：si_23100、液状化：pl_23100を表示する
							// 　　　県が選択された場合：震度：si、液状化：plを表示する
							// 上記以外：
							// 　　　震度：si、液状化：plを表示する
							var intCode = parseInt(data['features'][0]['properties']['code']);
							if ((intCode >= 23101 && intCode <= 23116 ) ||
							(data['features'][0]['properties']['code'].substr(0,3)=='231')){
								//名古屋市
								this.kenFlg = false;
							}else{
								//愛知県
								this.kenFlg = true;
							}
							console.debug('NEW this.kenFlg:'+ this.kenFlg);

							var kenFlg = this.kenFlg;
							this.map.getLayers().forEach(function(layer, i) {
								if (layer instanceof LayerGroup) {
									layer.getLayers().forEach(function(sublayer, j) {
										//地震がチェックされている場合
									if (wkcheckedLayers.indexOf('L100')!=-1){
											if (kenFlg){
												//県の場合
												if (sublayer.get('title')==='L102'){
													//名古屋市を強制非表示
													if (sublayer.get('visible')){
														sublayer.setVisible(false);
													}
												}
												if (sublayer.get('title')==='L101'){
													if (sublayer.get('visible')==false){
														sublayer.setVisible(true);
														console.log('地震 県を表示!!');
													}
												}
												shindoL = 'L101';
											}else{
												//市の場合
												//地震がチェック状態で既に県が選択されている場合は市への切り替えは行わない
												if (wkShindoLayer=="L101"){
													//県が選択されている場合
													//名古屋市の場合、名古屋市が選択されていたら県を表示
													if (sublayer.get('title')==='L101'){
															sublayer.setVisible(true);
															console.log('地震 県を表示!!');
													}
													//名古屋市の場合、名古屋市が選択されていたら市を非表示
													if (sublayer.get('title')==='L102'){
															sublayer.setVisible(false);
													}
													shindoL = 'L101';
												}else{
													//市が選択されている場合
													//名古屋市の場合、名古屋市が選択されていたら県を非表示
													if (sublayer.get('title')==='L101'){
															sublayer.setVisible(false);
													}
													//名古屋市の場合、名古屋市が選択されていたら市を表示
													if (sublayer.get('title')==='L102'){
															sublayer.setVisible(true);
															console.log('地震 市を表示!!');
													}
													shindoL = 'L102';
												}
											}
										}
										//液状化がチェックされている場合
									if (wkcheckedLayers.indexOf('L110')!=-1){
											if (kenFlg){
												//県の場合
												if (sublayer.get('title')==='L112'){
													//名古屋市を強制非表示
													if (sublayer.get('visible')){
														sublayer.setVisible(false);
													}
												}
												if (sublayer.get('title')==='L111'){
													if (sublayer.get('visible')==false){
														sublayer.setVisible(true);
														console.log('液状化 県を表示!!');
													}
												}
												ekijyoukaL = 'L111';
											}else{
											if (wkEkijyoukaLayer=="L111"){
													//名古屋市の場合、名古屋市が選択されていたら県を非表示
													if (sublayer.get('title')==='L111'){
														if (sublayer.get('visible')){
															sublayer.setVisible(true);
															console.log('地震 県を表示!!');
														}
													}
													//名古屋市の場合、名古屋市が選択されていたら市を表示
													if (sublayer.get('title')==='L112'){
															sublayer.setVisible(false);
													}
													ekijyoukaL = 'L111';
												}else{
													//市が選択されている場合
													//名古屋市の場合、名古屋市が選択されていたら県を非表示
													if (sublayer.get('title')==='L111'){
															sublayer.setVisible(false);
													}
													//名古屋市の場合、名古屋市が選択されていたら市を表示
													if (sublayer.get('title')==='L112'){
															sublayer.setVisible(true);
															console.log('地震 市を表示!!');
													}
													ekijyoukaL = 'L112';
												}
											}
										}
									});
									console.debug('changeShindoEkijyouka shindoL ' + shindoL);
									console.debug('changeShindoEkijyouka ekijyoukaL ' + ekijyoukaL);
								}
							});
						}else{
							console.log('no cityName!!');
							this.cityName = '（愛知県外）';
						}
					})
					.catch(err => {
						this.cityName = '取得できません。';
						console.log(err);
					})
					.finally(() => {
						this.$emit('changeShindoEkijyouka',{shindo:shindoL,ekijyouka:ekijyoukaL});//親へイベント発火を伝える
						this.emitToApp();
						this.centerGet();
					})
				}
			},
			/**
			 * 中心座標の属性取得を行う
			 */
			centerGet: function(){
				var url = "";
				var center_coordinate = transform(this.map.getView().getCenter(), 'EPSG:3857', 'EPSG:4326');
				var center_coordinate_2449 = proj4(proj4('EPSG:4326'), epsg_2449_def, center_coordinate);
				var viewResolution = /** @type {number} */ (this.map.getView().getResolution());

				//--------------------------------------
				//土地条件図レイヤー取得
				//--------------------------------------
				if (this.mode!='2'){
					console.log('土地条件図レイヤー取得対象外');
					url = false;
				}else{
					url = this.getUrl('L121',center_coordinate,viewResolution,'EPSG:4326');
				}
				if (url) {
					//BBOX変換
					// url = this.bboxConvert(url,611.4962263);
					url = this.bboxConvert2(url,0.000001);
					axios.get(url)
					.then(response => {
						var data = response.data;
						if (data['features'].length != 0){
							this.comment_q = data['features'][0]['properties']['comment_q'];
						}else{
							console.log('no comment_q!!');
							this.comment_q = '';
						}
					})
					.catch(err => {
						console.log('error comment_q!!');
						this.comment_q = '';
					})
					.finally(() => {
						console.log('out:'+this.comment_q);
						this.emitToApp();
					})
				}


				//--------------------------------------
				//浸水深レイヤー取得
				//--------------------------------------
				if (this.mode!='3'){
					console.log('浸水深レイヤー取得対象外');
					url = false;
				}else{
					url = this.getUrl('L211N',center_coordinate,viewResolution,'EPSG:4326');
				}
				// console.log('---浸水深レイヤー取得 start--------------');
				// console.log(url);
				if (url) {
					//BBOX変換
					// url = this.bboxConvert(url,611.4962263);
					url = this.bboxConvert2(url,0.000001);
					axios.get(url)
					.then(response => {
						var data = response.data;
						console.log(data);
						console.log(data['features'].length);
						if (data['features'].length != 0){
							this.depth = data['features'][0]['properties']['depth'];
						}else{
							console.log('no depth!!');
							this.depth = '';
						}
					})
					.catch(err => {
						console.log('error depth!!');
						this.depth = '';
					})
					.finally(() => {
						console.log('out:'+this.depth);
						this.emitToApp();
					})
				}

				//--------------------------------------
				//浸水深が30cmに到達する時間レイヤー取得
				//--------------------------------------
				if (this.mode!='3'){
					console.log('浸水深が30cmに到達する時間レイヤー取得対象外');
					url = false;
				}else{
					url = this.getUrl('L231N',center_coordinate,viewResolution,'EPSG:4326');
				}
				// console.log('---浸水深が30cmに到達する時間レイヤー取得 start--------------');
				// console.log(url);
				if (url) {
					//BBOX変換
					// url = this.bboxConvert(url,611.4962263);
					url = this.bboxConvert2(url,0.000001);
					axios.get(url)
					.then(response => {
						var data = response.data;
						if (data['features'].length != 0){
							this.time30 = data['features'][0]['properties']['time'];
						}else{
							console.log('no time30!!');
							this.time30 = '';
						}
					})
					.catch(err => {
						console.log('error time30!!');
						this.time30 = '';
					})
					.finally(() => {
						console.log('out:'+this.time30);
						this.emitToApp();
					})
				}

				//--------------------------------------
				//震度マップ（愛知県）レイヤー取得
				//--------------------------------------
				if (this.mode!='2'){
					console.log('震度マップ（愛知県）レイヤー取得対象外');
					url = false;
				}else{
					url = this.getUrl('L101',center_coordinate,viewResolution,'EPSG:4326');
				}
				// console.log('---震度マップ（愛知県）レイヤー取得 start--------------');
				// console.log(url);
				if (url) {
					//BBOX変換
					url = this.bboxConvert2(url,0.0001);
					axios.get(url)
					.then(response => {
						var data = response.data;
						if (data['features'].length != 0){
							this.si = data['features'][0]['properties']['si'];
						}else{
							console.log('no si!!');
							this.si = '';
						}
					})
					.catch(err => {
						console.log('error si!!');
						this.si = '';
					})
					.finally(() => {
						console.log('si:'+this.si);
						this.emitToApp();
					})
				}

				//--------------------------------------
				//震度マップ（名古屋市）レイヤー取得
				//--------------------------------------
				if (this.mode!='2'){
					console.log('震度マップ（名古屋市）レイヤー取得対象外');
					url = false;
				}else{
					url = this.getUrl('L102',center_coordinate,viewResolution,'EPSG:4326');
				}
				// console.log('---震度マップ（名古屋市）レイヤー取得 start--------------');
				// console.log(url);
				if (url) {
					//BBOX変換
					url = this.bboxConvert2(url,0.0001);
					axios.get(url)
					.then(response => {
						var data = response.data;
						if (data['features'].length != 0){
							this.si = data['features'][0]['properties']['si'];
						}else{
							console.log('no si!!');
							this.si = '';
						}
					})
					.catch(err => {
						console.log('error si!!');
						this.si = '';
					})
					.finally(() => {
						console.log('si:'+this.si);
						this.emitToApp();
					})
				}

				//--------------------------------------
				//液状化マップ（愛知県）レイヤー取得
				//--------------------------------------
				if (this.mode!='2'){
					console.log('液状化マップ（愛知県）レイヤー取得対象外');
					url = false;
				}else{
					url = this.getUrl('L111',center_coordinate,viewResolution,'EPSG:4326');
				}
				// console.log('---液状化マップ（愛知県）レイヤー取得 start--------------');
				// console.log(url);
				if (url) {
					//BBOX変換
					url = this.bboxConvert2(url,0.0001);
					axios.get(url)
					.then(response => {
						var data = response.data;
						if (data['features'].length != 0){
							this.pl = data['features'][0]['properties']['pl'];
						}else{
							console.log('no pl!!');
							this.pl = '';
						}
					})
					.catch(err => {
						console.log('error pl!!');
						this.pl = '';
					})
					.finally(() => {
						console.log('pl:'+this.pl);
						this.emitToApp();
					})
				}

				//--------------------------------------
				//液状化マップ（名古屋市）レイヤー取得
				//--------------------------------------
				if (this.mode!='2'){
					console.log('液状化マップ（名古屋市）レイヤー取得対象外');
					url = false;
				}else{
					url = this.getUrl('L112',center_coordinate,viewResolution,'EPSG:4326');
				}
				// console.log('---液状化マップ（名古屋市）レイヤー取得 start--------------');
				// console.log(url);
				if (url) {
					//BBOX変換
					url = this.bboxConvert2(url,0.0001);
					axios.get(url)
					.then(response => {
						var data = response.data;
						if (data['features'].length != 0){
							this.pl = data['features'][0]['properties']['pl'];
						}else{
							console.log('no pl!!');
							this.pl = '';
						}
					})
					.catch(err => {
						console.log('error pl!!');
						this.pl = '';
					})
					.finally(() => {
						console.log('pl:'+this.pl);
						this.emitToApp();
					})
				}

				//--------------------------------------
				//津波到達時間マップレイヤー取得
				//--------------------------------------
				if (this.mode!='3'){
					console.log('津波到達時間マップレイヤー取得対象外');
					// url = false;
				}else{
					// url = this.getUrl('L221',center_coordinate,viewResolution);
					if (this.isLayerVisible('L221')) {
						//if (this.features.tsunami_time.length == 0) {
							url = this.geoserverWfsUrl.substr(0, this.geoserverWfsUrl.length - 1)
								+ '?service=wfs'
								+ '&request=GetFeature'
								+ '&typename=bousai_aichi:tsunami_time'
								+ '&outputFormat=application/json'
								+ '&srsname=EPSG:2449'
								+ '&CQL_FILTER=DWITHIN(geom,Point('+center_coordinate_2449[1]+' '+center_coordinate_2449[0]+'),5,kilometers)';
							axios.get(url)
							.then(response => {
								var data = response.data;
								if (data['features'].length != 0){
									this.features.tsunami_time = new GeoJSON().readFeatures(data);
									var ret = this.getClosestDistance(this.features.tsunami_time, center_coordinate);
									this.time = this.features.tsunami_time[ret.idx].get('time');
									this.timeDist = ret.dist;
								}else{
									console.log('no time!!');
									this.time = '';
									this.timeDist = '';
								}
							})
							.catch(err => {
								console.log('error time!!');
								this.time = '';
								this.timeDist = '';
							})
							.finally(() => {
								console.log('time:'+this.time);
								console.log('timeDist:'+this.timeDist);
								this.emitToApp();
							})
						//} else {
						//	var ret = this.getClosestDistance(this.features.tsunami_time, center_coordinate);
						//	this.time = this.features.tsunami_time[ret.idx].get('time');
						//	this.timeDist = ret.dist;
						//	console.log('time:'+this.time);
						//	console.log('timeDist:'+this.timeDist);
						//	this.emitToApp();
						//}
					}
				}
				//--------------------------------------
				//津波波高マップレイヤー取得
				//--------------------------------------
				if (this.mode!='3'){
					console.log('津波波高マップレイヤー取得対象外');
					// url = false;
				}else{
					// url = this.getUrl('L201',center_coordinate,viewResolution);
					if (this.isLayerVisible('L201')) {
						//if (this.features.tsunami_height.length == 0) {
							url = this.geoserverWfsUrl.substr(0, this.geoserverWfsUrl.length - 1)
								+ '?service=wfs'
								+ '&request=GetFeature'
								+ '&typename=bousai_aichi:tsunami_height'
								+ '&outputFormat=application/json'
								+ '&srsname=EPSG:2449'
								+ '&CQL_FILTER=DWITHIN(geom,Point('+center_coordinate_2449[1]+' '+center_coordinate_2449[0]+'),5,kilometers)';
							axios.get(url)
							.then(response => {
								var data = response.data;
								if (data['features'].length != 0){
									this.features.tsunami_height = new GeoJSON().readFeatures(data);
									var ret = this.getClosestDistance(this.features.tsunami_height, center_coordinate);
									this.heightDist = ret.dist;
									this.height = this.features.tsunami_height[ret.idx].get('height');
								}else{
									console.log('no height!!');
									this.height = '';
									this.heightDist = '';
								}
							})
							.catch(err => {
								console.log('error height!!');
								this.height = '';
								this.heightDist = '';
							})
							.finally(() => {
								console.log('height:'+this.height);
								console.log('heightDist:'+this.heightDist);
								this.emitToApp();
							})
						//} else {
						//	var ret = this.getClosestDistance(this.features.tsunami_height, center_coordinate);
						//	this.height = this.features.tsunami_height[ret.idx].get('height');
						//	this.heightDist = ret.dist;
						//	console.log('height:'+this.height);
						//	console.log('heightDist:'+this.heightDist);
						//	this.emitToApp();
						//}
					}
				}
				//--------------------------------------
				//建物倒壊シミュレータ実行用震度レイヤー取得（地図非表示）
				//--------------------------------------
				if (this.mode!='2' && this.mode!='4' && this.mode!='5'){
					console.log('建物倒壊シミュレータ実行用震度レイヤー取得対象外');
				}else{
					//取得先レイヤ名の変更
					var typename = 'bousai_aichi:si';
					if(!this.kenFlg){
						typename = 'bousai_aichi:si_23100';
					}
					url = this.geoserverWfsUrl.substr(0, this.geoserverWfsUrl.length - 1)
						+ '?service=wfs'
						+ '&request=GetFeature'
						+ '&typename='+typename
						+ '&outputFormat=application/json'
						+ '&srsname=EPSG:4326'
						+ '&CQL_FILTER=DWITHIN(geom,Point('+center_coordinate[1]+' '+center_coordinate[0]+'),10,meters)';
					axios.get(url)
					.then(response => {
						var data = response.data;
						if (data['features'].length != 0){
							this.features.si = new GeoJSON().readFeatures(data);
							var ret = this.getClosestDistance(this.features.si, center_coordinate);
							this.si = this.features.si[ret.idx].get('si');
							if(this.mode==='5'){//シミュレータ詳細版の場合はメッシュコードも取得
								this.mcode = this.features.si[ret.idx].get('mcode');
								console.log('mcode sim:'+this.mcode);
							}
						}else{
							console.log('no si!!');
							this.si = '';
						}
					})
					.catch(err => {
						console.log('error si!!');
						this.si = '';
					})
					.finally(() => {
						console.log('si sim:'+this.si);
						this.emitToApp();
					})
				}
			},
			/**
			 * 地図ドラッグ時の自動処理呼び出し関数：addOnLoadで呼び出す
			 */
			tracetoggle: function(){
				var objmap = this.map._map;	//OpenLayersのオブジェクト
				if (objmap) {
					if (!this.traceflag) {
						//地図ドラッグ後の実行関数を登録
						objmap.events.register("moveend", objmap, dragAction);
						//シナリオモードEnterキー入力対応
						// objmap.events.register("mouseup", objmap, focusHold);
						this.traceflag = true;
					} else {
						objmap.events.remove("moveend", objmap.map);
						this.traceflag = false;
					}
				}
			},
			/**
			 * sublayer取得する
			 */
			getUrl: function(layer_title,center_coordinate,viewResolution,proj) {
				var wmsSource = '';
				var visible = false;
				this.map.getLayers().forEach(function(layer, i) {
					if (layer instanceof LayerGroup) {
						layer.getLayers().forEach(function(sublayer, j) {
							if (sublayer.get('title')===layer_title){
								wmsSource = sublayer;
								visible = sublayer.get('visible');
							}
						});
					}
				});
				//レイヤ非表示の場合は属性取得を行わない
				if (visible == false){
					return false;
				}
				// var center_coordinate = this.map.getView().getCenter();
				// var viewResolution = /** @type {number} */ (this.map.getView().getResolution());
				var url = wmsSource.get('source').getFeatureInfoUrl(
					// evt.coordinate,
					[center_coordinate[0],center_coordinate[1]],
					viewResolution,
					proj,
					//'EPSG:3857',
					{
					'INFO_FORMAT': 'application/json',
					feature_count: 5
					}
					);
				return url;
			},
			/**
			 * URLのBBOXの値を調整する
			 */
			bboxConvert: function(url,hosei) {
				var durl = url.split('BBOX=');
				var wkbbox = decodeURIComponent(durl[1]);

				var bbox = wkbbox.split(',');
				var bbox2 = parseFloat(bbox[2])+hosei;
				var bbox3 = parseFloat(bbox[3])+hosei;
				var wk = bbox[0] +','+ bbox[1] +','+ String(bbox2) +','+ String(bbox3);
				console.debug(wk);
				wk = encodeURIComponent(wk);
				url = durl[0] + 'BBOX=' +  wk;
				console.log('convert url:' + url);
				return url;
			},

			/**
			 * URLのBBOXの値を調整する
			 */
			bboxConvert2: function(url,hosei) {
				var durl = url.split('BBOX=');
				var wkbbox = decodeURIComponent(durl[1]);
				var center = this.map.getView().getCenter();
				var x1 = center[0];
				var y1 = center[1];
				var x2 = center[0];
				var y2 = center[1];
				var lonlat1 = transform([x1,y1], 'EPSG:3857', 'EPSG:4326');
				var lonlat2 = transform([x2,y2], 'EPSG:3857', 'EPSG:4326');
				console.debug('****************');
				console.debug(x1);
				console.debug(y1);
				console.debug(x2);
				console.debug(y2);
				console.debug(lonlat1[0]);
				console.debug(lonlat1[1]);
				console.debug(lonlat2[0]);
				console.debug(lonlat2[1]);
				console.debug('****************');
				var wk = String(lonlat1[1]) +','+ String(lonlat1[0]) +','+ String(lonlat2[1]+hosei) +','+ String(lonlat2[0]+hosei);
				// var wk = String(x1) +','+ String(y1) +','+ String(x2) +','+ String(y2);
				wk = encodeURIComponent(wk);
				url = durl[0] + 'BBOX=' +  wk;
				console.log('convert url:' + url);
				return url;
			},
			/**
			 * 親APPに表示用の値を受け渡す
			 */
			emitToApp: function() {
				this.$emit('input', {
					lon: this.lon,
					lat: this.lat,
					lonValue: this.lonValue,
					latValue: this.latValue,
					scaleValue: this.scaleValue,
					zoomValue: this.zoomValue,
					cityName: this.cityName,
					comment_q:this.comment_q,
					time:this.time,
					timeDist:this.timeDist,
					time30:this.time30,
					depth:this.depth,
					si:this.si,
					pl:this.pl,
					mcode:this.mcode,
					height:this.height,
					heightDist:this.heightDist,
					layerMenuPos: this.layerMenuPos,
					dicBaseLayers:JSON.stringify(this.dicBaseLayers),
					dicLayers:JSON.stringify(this.dicLayers),
					kenFlg:this.kenFlg,
					mode:this.mode,

					// checkedRightLayers:JSON.stringify(this.checkedRightLayers),
					// checkedRightAllLayers:JSON.stringify(this.checkedRightAllLayers)
				});
			},

			/**
			 * 地図ドラッグ後の自動処理
			 */
			dragAction: function() {
				// ループ防止：中心点が前回のメソッド呼び出し時と
				// 変わっていなければ再度移動しない
				var centerCurL = this.map.getCenter();	// 現在の中心座標を取得

				// 以下は中心座標が前回のメソッド呼び出し時から動いている（ループでない）場合のみ実行する
				if(centerCurL != this.centerMemL){

					// 今回の中心座標を保持する：ループ防止
					this.centerMemL = centerCurL;

					// 中心点の属性を取得し、いろいろな自動処理を行う
					this.getCenterAttribute();
				}
			},
			/**
			 * 中心点の属性を取得し、いろいろな自動処理を行う
			 */
			getCenterAttribute: function() {
				if(this.searchingflag != true) {
					// 現在の中心点座標からジオメトリ変数を生成
					var c = this.map.getCenter();
					var d = 1 / 3600000;//1ミリ秒
					var bbox = [(c.lon-d),(c.lat-d),(c.lon+d),(c.lat+d)];
					this.searchingflag = true;	// 検索リクエスト実行フラグON
				} else {
					console.debug("別の属性検索が実行中です.");
					return false;
				}
			},
			//fullScreen: function () {
			//	this.map.baseLayer().redraw();
			//	this.gmap.baseLayer().redraw();
			//},
			//レイヤーの再表示
			reShowLayer(checkedRightLayers,checkedRightAllLayers){
				console.log('reShowLayerレイヤーの表示' + checkedRightLayers);
				console.log('reShowLayerレイヤーの表示' + checkedRightAllLayers);
			},
			//レイヤーの表示・非表示
			// showLayer: function(title,visible) {
			showLayer: function(eventArgs) {
				console.log('レイヤーの表示・非表示' + eventArgs.value);
				console.log('レイヤーの表示・非表示' + eventArgs.display);
				console.log('レイヤーの表示・非表示' + eventArgs.checkedLayers);
				console.log('レイヤーの表示・非表示' + eventArgs.checkedAllLayers);
				this.checkedLayers = eventArgs.checkedLayers;
				this.checkedAllLayers = eventArgs.checkedAllLayers;
				var title = eventArgs.value;
				var visible = eventArgs.display;
				var hideLayer = "";
				
				//過去の航空写真のON/OFFで地理院許可番号表示ON/OFF
				//if(eventArgs.value == "L003"){
				//	if(eventArgs.display == true){
				//		this.oldPhotoFlag = true;
				//	//}else{
				//	//	this.oldPhotoFlag = false;
				//	}
				//	//console.log('oldPhotoFlagL:'+this.oldPhotoFlagL);
				//}

				//地震の場合
				if (title ==='L100'){
					//県の場合は無条件にL101を表示
					if (this.kenFlg){
						hideLayer='L102';
						title = 'L101'
					}else{
						//市の場合はラジオボタンの状態に応じて表示切替
						if (this.checkedAllLayers.indexOf('L102')!=-1){
							hideLayer='L101';
							title = 'L102'
						} else if (this.checkedAllLayers.indexOf('L101')!=-1){
							hideLayer='L102';
							title = 'L101'
						} else {
							hideLayer='L101';
							title = 'L102'
						}
					}
				}
				//液状化の場合
				else if (title ==='L110'){
					//県の場合は無条件にL111を表示
					if (this.kenFlg){
						hideLayer='L112';
						title = 'L111'
					}else{
						//市の場合はラジオボタンの状態に応じて表示切替
						if (this.checkedAllLayers.indexOf('L112')!=-1){
							hideLayer='L111';
							title = 'L112'
						} else if (this.checkedAllLayers.indexOf('L111')!=-1){
							hideLayer='L112';
							title = 'L111'
						} else {
							hideLayer='L111';
							title = 'L112'
						}
					}
				}

				//背景図レイヤ定義
				var L001 = "";
				var L002 = "";
				var L003 = "";
				
				//通常レイヤ
				this.map.getLayers().forEach(function(layer, i) {
					if (layer instanceof LayerGroup) {
						layer.getLayers().forEach(function(sublayer, j) {
							//航空写真（過去）
							if(sublayer.get('title')==="L003"){
								L003 = sublayer;
							}else{
								//表示レイヤー
								if (sublayer.get('title')===title){
									console.log('レイヤーのtitle:' + title);
									console.log('レイヤーのvisible:' + visible);
									sublayer.setVisible(visible);
								}
								//非表示レイヤー
								if (sublayer.get('title')===hideLayer){
									console.log('非表示レイヤーのhideLayer:' + hideLayer);
									console.log('非表示レイヤーのvisible:' + visible);
									sublayer.setVisible(false);
								}
							}
						});
					}else{//背景図
						//地図
						if(layer.get('title')==="L001"){
							L001 = layer;
						//航空写真（現在）
						}else if(layer.get('title')==="L002"){
							L002 = layer;
						}
					}
				});

				//背景図表示レイヤー切替
				if (title==="L001"){
					L001.setVisible(true);
					L002.setVisible(false);
					L003.setVisible(false);
					this.oldPhotoFlag = false;
				}else if (title==="L002"){
					L001.setVisible(false);
					L002.setVisible(true);
					L003.setVisible(false);
					this.oldPhotoFlag = false;
				}else if (title==="L003"){
					L001.setVisible(false);
					L002.setVisible(false);
					L003.setVisible(true);
					this.oldPhotoFlag = true;
				}

				//GoogleMaps対応、レイヤが変わると、ZoomLevelもまた+10戻るので再設定
				//var gmapThis = this.gmap;
				var newZoom = this.map.getView().getZoom();
				//レイヤ変更だけでもLevelが中途半端な値になるときがあるので整数化
				newZoom = Math.round(newZoom);
				this.map.getView().setZoom(newZoom);
				//すぐに実行しても反映されないので、少し待ってから実行する
				//航空写真及び地図で最大のL18：1.5秒
				/*
				if((title==="L001"|| title==="L002") && newZoom == 18){
					setTimeout(function() {
						gmapThis.setZoom(newZoom);
						console.log("showLayer 1500 : "+title+", setZoom:"+newZoom);
					}, 1500);
				//航空写真及び地図でL17以上：：0.5秒
				}else if((title==="L001"|| title==="L002") && newZoom < 18){
					setTimeout(function() {
						gmapThis.setZoom(newZoom);
						console.log("showLayer 500 : "+title+", setZoom:"+newZoom);
					}, 500);
				//その他レイヤ：0秒
				}else{
					gmapThis.setZoom(newZoom);
					console.log("showLayer 0 : "+title+", setZoom:"+newZoom);
				}
				*/
			},
			//ズームレベル
			setZoom: function(zoomValue){
				console.debug('ズームレベル:'+zoomValue);
				//this.currZoom = Math.round(zoomValue);
				this.zoomValue = Math.round(zoomValue);
				this.map.getView().setZoom(this.zoomValue);
				//this.gmap.setZoom(this.zoomValue);//for GoogleMaps
			},
			//中心移動
			centerMove: function(lon,lat){
				console.debug("map中心移動");
				console.debug(lon);
				console.debug(lat);
				this.lon = lon;
				this.lat = lat;
				this.lonValue = getDMS(lon);
				this.latValue = getDMS(lat);

				var v = this.map.getView();
				v.animate({
					center: fromLonLat([lat,lon]),
					duration: 0
				});
			},
			//２画面切り替え
			toggleDoubleScreen: function() {
				this.isDoubleScreen = !this.isDoubleScreen;
				//中心に移動する
				var center = toLonLat( this.map.getView().getCenter() );
				this.centerMove(center[1],center[0])
				console.log("mapPane toggleDoubleScreen 中心に移動する!!");
				console.log(center[1]);
				console.log(center[0]);


				if (this.isDoubleScreen){
					this.$nextTick(() => {
							console.log(this.isDoubleScreen);
						})
					this.$forceUpdate();
				}else{
					this.$nextTick(() => {
							console.log(this.isDoubleScreen);
						})
					this.$forceUpdate();
				}
				//全画面から2画面に切り替えで地図が再描画されないので強制的にDOMを書き換えて対応　openlayerのバグ？
				const targetElement = this.$refs.map1;
				if (this.isDoubleScreen){
				this.$refs.map1.className = "doublescreen";
				}else{
				this.$refs.map1.className = "singlescreen";
				}
				const targetElementclassName = this.$refs.map1.className;
				console.log('対象のDOM：', targetElement);
				console.log('対象のDOMのテキスト：', targetElementclassName);
				this.map.updateSize();
			},
			//震度と液状化の市、県ラジオボタンの値 LayerMenu=>App=>Map
			shindoMenuLayer(Layer){
				console.log('map shindoMenuLayer:'+Layer);
				this.shindoLayer= Layer;
			},
			ekijyoukaMenuLayer(Layer){
				console.log('map ekijyoukaMenuLayer:'+Layer);
				this.ekijyoukaLayer= Layer;
			},
			getClosestDistance: function(features, center_coordinate) {
				//var lonLat = toLonLat(center_coordinate, 'EPSG:3857');
				//var center = fromLonLat(lonLat, 'EPSG:2449');
				var center = proj4(proj4('EPSG:4326'), epsg_2449_def, center_coordinate);
				var minDist = null;
				var minIdx = null;
				features.forEach(function(feature, i) {
					var closest = feature.getGeometry().getClosestPoint(center);
					var dist = (new LineString([center, closest])).getLength();
					if (minDist == null || dist < minDist) {
						minDist = dist;
						minIdx = i;
					}
				});
				return {
					dist: minDist,
					idx: minIdx
				};
			},
			isLayerVisible: function(title) {
				var visible = false;
				this.map.getLayers().forEach(function(layer, i) {
					if (layer instanceof LayerGroup) {
						layer.getLayers().forEach(function(sublayer, j) {
							if (sublayer.get('title') === title) {
								visible = sublayer.get('visible');
							}
						});
					}else{//GoogleMaps
						if (layer.get('title') === title) {
							visible = layer.get('visible');
						}
					}
				});
				return visible;
			},
		}
	}
	function getDMS(DecimalDegree){
		var degree = parseInt(DecimalDegree);
		var minute = parseInt((DecimalDegree - degree) * 60);
		var second = parseInt(((DecimalDegree - degree) * 60 - minute) * 60);
		return String(degree) + "度" + String(minute) + "分" + String(second) + "秒";
	}
	function scaleControl() {
		control = new ScaleLine({
			units: 'metric'
		});
		return control;
	}
	//マップあいちのレイヤ追加用
	function createLayerGroup(ids, minZoom){
		var aichiLayers = [];
		for(var i=0; i<ids.length; i++){
			var tile = new TileLayer({
				source: new TileWMS({
					//url: aichiwms,
					url:mapinfo['options']['geoServerURL'],
					params:{
						'LAYERS':ids[i][0],
						'TILED':true
					},
					serverType:'geoserver',
					transition:0
				}),
				visible:false,
				dispName: ids[i][1],
				groupName:'',
				title:ids[i][0]
			});
			//特定のレイヤは表示縮尺の制限する
			if(ids[i][0]=="c205031"){//水害情報＞津波＞津波最大浸水深
				tile.setMinZoom(15);
			}
			if(ids[i][0]=="c204283"){//水害情報＞高潮
				tile.setMinZoom(11);
			}
			//minZoomがtrueのレイヤは全て制限
			if(minZoom){
				tile.setMinZoom(11);
			}
			aichiLayers.push(tile);
		}
		return new LayerGroup({layers:aichiLayers});
	}

</script>

<style>
/* <style scoped> scoped指定だとzoomsliderのstyle指定が効かなくなる！！*/
@import "../../css/MapPane.css";

</style>

